import React from "react";

export const ConfirmationModal: React.FC<{
    isOpen?: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
  }> = ({ isOpen, title, message, onConfirm, onCancel, isLoading = false }) => {
    if (!isOpen) return null;
  
    return (
      <>
        <div className="modal fade show in" id="confirmationModal">
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <h5 className="font-weight-semibold">{title}</h5>
                      <p>{message}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 px-4 mr-1"
                        onClick={onCancel}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="button"
                        className="btn btn-primary py-2 px-4"
                        onClick={onConfirm}
                        disabled={isLoading}
                      >
                        {isLoading ? "Processing..." : "Confirm"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    );
  };